import Model from '../orm/Model'

export default class Cancellation extends Model {
    
    static entity = 'cancellations'

    static fields() {
        return {
            id: this.attr(null),
            course_id: this.attr(null),
            date: this.attr(''),
            notes: this.attr('')
        }
    }

    static graphql = {
        all: {
            paginated: true,
            parameters: {
                page: 'Int!',
                per_page: 'Int',
                sort_by: 'String',
                sort_dir: 'String'
            }
        },
        one: {
            type: 'cancellation',
            parameters: {
                id: 'Int!'
            }
        },
        create: {
            type: 'createCancellation',
            parameters: {
                course_id: 'Int!',
                date: 'String!',
                notes: 'String'
            }
        },
        remove: {
            type: 'removeCancellation',
            parameters: {
                id: 'Int!'
            }
        }
    }
}